export const PositionCode = [
    "O1227",
    "O1226",
    "O1235",
    "O1234",
    "O3980",
    "O3979",
    "O3978",
    "O3977"
]